export enum GroupEmployeeFileDocumentView {
  NotValid = 0,
  Actual = 1,
  Pasado = 2,
  Anterior = 3,
  Ultimos = 4,
  Custom = 5,
  All = 6,
  Pendings = 7,
  SignPending = 8
}
